<template>
  <div class="card">
    <div class="card-image">
      <a @click="isPurchaseModalActive = true">
        <figure class="image is-4by3">
          <img
            src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_3x2.png"
            alt="Placeholder image"
          />
        </figure>
      </a>
    </div>
    <div class="card-content">
      <div class="content">
        <div class="columns">
          <div class="column is-10">
            <a @click="isPurchaseModalActive = true">
              <span class="ellipsis is-size-6 has-text-dark-primary">{{
                purchase.attributes.name
              }}</span>
            </a>

            <span v-if="store" class="ellipsis is-size-7">
              from
              <router-link
                aria-current="store"
                :to="{ path: `/stores/${store.attributes.nickname}` }"
              >
                <span class="has-text-weight-semibold has-text-dark-primary">{{
                  store.attributes.name
                }}</span>
              </router-link>
            </span>
            <span v-else class="ellipsis has-text-gray is-size-7">ㅤ</span>

            <b-tooltip
              append-to-body
              type="is-gray"
              :label="`Last update ${dateFromNow(purchase.attributes.updated_at)}`"
            >
              <small class="is-italic has-text-gray">
                <b-icon size="is-small" icon="update"></b-icon>
                <time datetime="2016-1-1">{{
                  formatDate(purchase.attributes.created_at)
                }}</time>
              </small>
            </b-tooltip>
          </div>
          <div class="column is-narrow">
            <b-tooltip
              append-to-body
              position="is-left"
              :label="purchase.attributes.craft_purchase_category.data.attributes.name"
            >
              <b-icon
                :icon="
                  craftPurchaseGetIconName(
                    purchase.attributes.craft_purchase_category.data.id
                  )
                "
              ></b-icon>
            </b-tooltip>
          </div>
        </div>
        <div v-if="owner" class="has-text-centered">
          <b-icon icon="menu"></b-icon>
        </div>
      </div>
    </div>

    <b-modal
      :active.sync="isPurchaseModalActive"
      :can-cancel="true"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <purchase @purchaseUpdated="purchaseUpdated" :purchase="purchase" />
    </b-modal>
  </div>
</template>

<script>
import { dateMixin } from '@/mixins/dateMixin'
import Purchase from '@/views/Project/Purchase'
import { craftPurchaseCategoryMixin } from '@/mixins/craftPurchaseCategoryMixin'

export default {
  props: ['purchase', 'owner'],
  mixins: [dateMixin, craftPurchaseCategoryMixin],
  components: {
    Purchase
  },
  methods: {
    purchaseUpdated (values) {
      this.$emit('purchaseUpdated', values)
    }
  },
  computed: {
    store () {
      return this.purchase.attributes.store.data
    }
  },
  data () {
    return {
      isPurchaseModalActive: false
    }
  }
}
</script>
